import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

// Global styles (TailwindCSS assumed)

const Layout = ({ children }) => {
  const [showMobileNav, setShowMobileNav] = React.useState(false);
  return (
    <div className="flex flex-col min-h-screen font-sans text-gray-800">
      <header>
        <div
          className="bg-white shadow-md sticky top-0 z-50 w-full px-2 md:px-4 py-2 md:py-3 flex flex-col md:flex-row md:justify-end text-teal-500 text-base md:text-lg">
          <ul className="flex flex-col md:flex-row md:space-x-36 space-y-1 md:space-y-0">
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" className="inline h-4 w-4 md:h-5 md:w-5 mr-1" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a2 2 0 011.94 1.47l.7 2.1a2 2 0 01-.45 2.11l-1.27 1.27a16.06 16.06 0 006.58 6.58l1.27-1.27a2 2 0 012.11-.45l2.1.7A2 2 0 0121 18.72V21a2 2 0 01-2 2h-1C7.61 23 1 16.39 1 8V7a2 2 0 012-2z"/>
              </svg>
              <span className="text-sm md:text-lg">Office: <a href="tel:01992637350" className="hover:underline">01992 637350</a></span>
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" className="inline h-4 w-4 md:h-5 md:w-5 mr-1" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a2 2 0 011.94 1.47l.7 2.1a2 2 0 01-.45 2.11l-1.27 1.27a16.06 16.06 0 006.58 6.58l1.27-1.27a2 2 0 012.11-.45l2.1.7A2 2 0 0121 18.72V21a2 2 0 01-2 2h-1C7.61 23 1 16.39 1 8V7a2 2 0 012-2z"/>
              </svg>
              <span className="text-sm md:text-lg">Mobile: <a href="tel:07980989127" className="hover:underline">07980 989127</a></span>
            </li>
            <li>
                        <span className="text-sm md:text-lg">@
                          Email: <a href="mailto:brookfieldcarpetcleaning@gmail.com"
                                    className="break-all">brookfieldcarpetcleaning@gmail.com</a>
                        </span>
            </li>
          </ul>
        </div>
        <div className={`container mx-auto px-4 py-3 flex flex-row justify-between items-center`}>
                <Link to="/" className="text-2xl font-bold text-blue-700 mb-2 md:mb-0">
                  <img src="/img/logonew.png" alt="Brookfield Carpet Cleaning Company" className="h-20 md:h-32 mr-4"/>
                </Link>
                {/* Hamburger menu for mobile */}
                <div className="md:hidden flex items-center">
                  <button
                    className="text-3xl text-teal-500 focus:outline-none"
                    onClick={() => setShowMobileNav((prev) => !prev)}
                    aria-label="Open navigation"
                  >
                    &#9776;
                  </button>
                </div>
                {/* Desktop nav */}
                <nav
                  className="space-x-0 space-y-2 md:space-x-4 md:space-y-0 flex-col md:flex-row text-lg md:text-2xl hidden md:flex">
                  <Link to="/" className="hover:text-teal-400">Home</Link>
                  <Link to="/pricing" className="hover:text-teal-400">Pricing</Link>
                  <Link to="/residential" className="hover:text-teal-400">Residential</Link>
                  <Link to="/commercial" className="hover:text-teal-400">Commercial</Link>
                </nav>
                {/* Mobile nav dropdown */}
                {showMobileNav && (
                  <nav className="fixed top-0 left-0 w-full h-full bg-white bg-opacity-95 shadow-lg flex flex-col items-center py-20 md:hidden z-50">
                    <Link to="/" className="hover:text-teal-400 py-2 text-2xl" onClick={() => setShowMobileNav(false)}>Home</Link>
                    <Link to="/pricing" className="hover:text-teal-400 py-2 text-2xl"
                          onClick={() => setShowMobileNav(false)}>Pricing</Link>
                    <Link to="/residential" className="hover:text-teal-400 py-2 text-2xl"
                          onClick={() => setShowMobileNav(false)}>Residential</Link>
                    <Link to="/commercial" className="hover:text-teal-400 py-2 text-2xl"
                          onClick={() => setShowMobileNav(false)}>Commercial</Link>
                  </nav>
                )}
              </div>
      </header>
      <main className="flex-1 container mx-auto px-2 md:px-4 py-4 md:py-6">{children}</main>
      <section className="container mx-auto px-2 md:px-4 flex flex-col md:flex-row gap-4 md:gap-6 mt-8 justify-center bg-white rounded-lg shadow-md">
              <div className="flex-1 p-4 md:p-6 flex flex-col justify-center">
                <h2 className="text-xl md:text-3xl font-bold mb-4">Contact us for a quote</h2>
                <ul className="text-lg md:text-2xl list-disc ml-6 space-y-2">
                  <li>Office: <a href="tel:01992637350" className="hover:underline">01992 637350</a></li>
                  <li>Mobile: <a href="tel:07980989127" className="hover:underline">07980 989127</a></li>
                  <li><a href="mailto:brookfieldcarpetcleaning@gmail.com"
                                className="text-blue-500 break-all">Or Email</a></li>
                </ul>
              </div>
              <div className="flex-1 flex p-3 items-center justify-center">
                <img src="img/goodasnew2.jpg" className="h-40 md:h-64 w-auto" alt="Good as new"/>
              </div>
            </section>
      <footer className="bg-gray-100 py-4 mt-6">
        <div className="container mx-auto px-2 md:px-4 text-center text-xs md:text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Brookfield Carpet Cleaning. All rights reserved.
        </div>
      </footer>
    </div>
  );}

// --- The rest of the page components below use mobile-first responsive classes ---

  const Home = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = React.useState(0);
  
  const videos = [
    "img/gallery/video.mp4",
    "img/gallery/video1.mp4",
    "img/gallery/video2.mp4"    
  ];
  
  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentVideoIndex((prev) => (prev + 1) % videos.length);
    }, 27000);
    
    return () => clearInterval(interval);
  }, [videos.length]);
  
  const images = [
    "img/gallery/ba1.webp",
    "img/gallery/ba2.webp", 
    "img/gallery/ba3.webp",
    "img/gallery/ba4.webp",
    "img/gallery/ba5.webp",
    "img/gallery/bedroom.webp",
    "img/gallery/machine.webp",
    "img/gallery/lounge.webp",
    "img/gallery/office.webp",
    "img/gallery/carpet.webp",
    "img/gallery/video1.mp4",
  ];
  
  return (
    <div className="space-y-8">
      <section className="text-center py-8 md:py-12 bg-blue-50 rounded-xl">
        <h1 className="text-2xl md:text-4xl font-bold mb-4 text-teal-500">Professional Carpet and Upholstery Cleaning Services</h1>
        <p className="max-w-screen-xl mx-auto text-base md:text-lg text-gray-600">
          <b>✨ Fresh Carpets. Healthier Home. Happier You.</b>
          <br/><br/>
          <section className="mt-1 flex flex-col md:flex-row items-center justify-center gap-12 mb-6">
              <ul className="text-left space-y-2">
                <li>✅ Prochem Academy trained</li>
                <li>✅ Deep cleaning & stain removal</li>
                <li>✅ Free deodorising treatment</li>
                <li>✅ Fast, friendly & flexible service</li>
                <li>✅ Fully insured</li>
              </ul>
              <div className="flex justify-center">
                <img
                  src="img/goodasnew2_transparent.png"
                  className="h-40 md:h-64 w-auto"
                  alt="Good as new"
                />
              </div>
            </section>

          📞 Get your free instant quote today — and love your carpets again!
        </p>

<div className="mt-6 flex flex-col md:flex-row md:space-x-4 space-y-2 md:space-y-0 items-center justify-center">
            <Link to="/pricing" className="px-6 py-3 bg-teal-500 text-white rounded-lg hover:bg-teal-400">View
              Pricing</Link>
            <Link to="/residential"
                  className="px-6 py-3 border border-teal-500 text-teal-500 rounded-lg hover:bg-blue-50">Our
              Services</Link>
          </div>
          
      </section>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-4 md:p-6 bg-white rounded-lg shadow-md text-base md:text-xl">
          <b>Fresh, Clean, Like New – Every Time</b>
          <br/><br/>
          At Brookfield Carpet Cleaning, we deliver top-quality carpet and upholstery cleaning at highly competitive
          rates.
          <br/><br/>
          Serving Hertfordshire, Essex, and North London, our fully insured, Prochem Academy trained, we use the
          latest cleaning technology to remove dirt, stains, and allergens — leaving your carpets fresh, safe, and
          revitalised.
          <br/><br/>
          Covering residential, businesses, pubs, clubs, and care homes, offering a service that’s fast, friendly, and
          tailored to your schedule.
          <br/><br/>
          <b>Why choose us?</b>
          <br/><br/>
          <ul>
            <li>Advanced deep-cleaning machines for the best results</li>
            <li>Trusted by major commercial clients and hundreds of happy homeowners</li>
            <li>Flexible appointments and free instant quotes</li>
          </ul>
          Bring your carpets back to life — book your free, no-obligation quote today.
        </div>
        <div className="p-4 md:p-6 bg-white rounded-lg shadow-md flex justify-center items-center">
  <video
    key={currentVideoIndex}
    className="MXaqLd shaka-video"
    autoPlay
    muted
    playsInline
    loop
    src={videos[currentVideoIndex]}
  />
</div>
      </section>
      <section className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        <div className="p-4 md:p-6 bg-teal-500 rounded-lg shadow-md text-center">
          <h3 className="text-lg md:text-xl font-semibold mb-2 text-white">Residential</h3>
          <p className="text-white">Deep cleaning for carpets, rugs, and upholstery in your home.</p>
        </div>
        <div className="p-4 md:p-6 bg-teal-500 rounded-lg shadow-md text-center">
          <h3 className="text-lg md:text-xl font-semibold mb-2 text-white">Commercial</h3>
          <p className="text-white">Professional cleaning to maintain a spotless workspace.</p>
        </div>
        <div className="p-4 md:p-6 bg-teal-500 rounded-lg shadow-md text-center">
          <h3 className="text-lg md:text-xl font-semibold mb-2 text-white">Eco-Friendly</h3>
          <p className="text-white">Safe, sustainable cleaning solutions for your family and the environment.</p>
        </div>
      </section>
      <section className="py-8 bg-white">
      <h2 className="text-xl md:text-2xl font-bold text-center mb-6 text-teal-600">
        Our Work
      </h2>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={1.2} // mobile-first
        loop={true}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        breakpoints={{
          768: { slidesPerView: 2.5 }, // tablets
          1024: { slidesPerView: 3.5 }, // desktops
        }}
        className="px-4"
      >
        {images.map((src, i) => (
          <SwiperSlide key={i}>
            <div className="w-full h-80 md:h-96 rounded-xl shadow-lg overflow-hidden">
              <img
                src={src}
                alt={`Gallery ${i + 1}`}
                className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
    </div>
  );
};

  const Pricing = () => (
    <div>
      <h2 className="text-3xl font-bold mb-4">Pricing</h2>
      <p className="mb-6 text-gray-600 text-2xl">Transparent pricing for all our services.</p>
      <section className="grid md:grid-cols-2 gap-6">
        <div className="p-6 bg-white rounded-lg shadow-md text-center">
          <div>
            <h3 className="text-2xl font-bold mb-4">Carpet Cleaning Price List</h3>
            <p className="mb-2 text-gray-600 text-xl">Minimum Charge: £45.00</p>
            <p className="mb-2 text-gray-600 text-l">Some locations may incur an additional charge.</p>
            <p className="mb-2 text-gray-600 text-l">Prices are based on standard sized rooms, larger areas will incur
              an additional charge.</p>
          </div>
          <div className="space-y-4 text-xl">
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          Lounge <span className="text-xs">(15ft x 12ft)</span>
        </span>
              <span className="font-semibold">£40</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          Through Lounge <span className="text-xs">(20ft x 12ft)</span>
        </span>
              <span className="font-semibold">£50</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
              <span>Stairs & Landing</span>
              <span className="font-semibold">£40</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
              <span>Hallway, Stairs & Landing</span>
              <span className="font-semibold">£50</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
              <span>Dining Room <span className="text-xs">(12ft x 10ft)</span> </span>
              <span className="font-semibold">£30</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          Single Bedroom <span className="text-xs">(10ft x 8ft)</span>
        </span>
              <span className="font-semibold">£20</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          Double Bedroom <span className="text-xs">(12ft x 10ft)</span>
        </span>
              <span className="font-semibold">£25</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
              <span>Master Bedroom <span className="text-xs">(15ft x 12ft)</span></span>
              <span className="font-semibold">£35</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
              <span>Bathroom</span>
              <span className="font-semibold">£10</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
              <span>Commercial Carpet Cleaning</span>
              <span className="font-semibold">From £2.50/m²</span>
            </div>
          </div>
        </div>
        <div className="p-6 bg-white rounded-lg shadow-md text-center">
          <div>
            <h3 className="text-2xl font-bold mb-4">Upholstery Cleaning - Leather & Fabric</h3>
            <p className="mb-6 text-gray-600 text-xl">We also provide Vehicle Upholstery Cleaning - Call us for a
              quote</p>
            <p className="mb-6 text-gray-600 text-l"><br/></p>
          </div>
          <div className="space-y-4 text-xl">
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          Armchair
        </span>
              <span className="font-semibold">£30</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          2 Seater Sofa
        </span>
              <span className="font-semibold">£50</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
              <span>3 Seater Sofa</span>
              <span className="font-semibold">£55</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
              <span>Corner Sofas....</span>
              <span className="font-semibold">from £80</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
              <span>Foot Stool</span>
              <span className="font-semibold">£15</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          Dining Room Chairs <span className="text-xs">(just seat)</span>
        </span>
              <span className="font-semibold">£5</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          Dining Room Chairs <span className="text-xs">(whole chair)</span>
        </span>
              <span className="font-semibold">£10</span>
            </div>
          </div>
        </div>
      </section>
      <section className="grid md:grid-cols-1 gap-6 mt-4">
        <div className="p-6 bg-white rounded-lg shadow-md text-center">
          <div>
            <h3 className="text-2xl font-bold mb-4">Rugs</h3>
            <p className="mb-6 text-gray-600 text-xl">We do not charge VAT on any of our price</p>
          </div>
          <div className="space-y-4 text-xl">
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          Small Rug <span className="text-xs">(6ft x 3ft)</span>
        </span>
              <span className="font-semibold">£15</span>
            </div>
            <div className="p-4 border rounded-lg flex justify-between">
        <span>
          Large Rug <span className="text-xs">(up to 10ft x 5ft)</span>
        </span>
              <span className="font-semibold">£20</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );

  const Residential = () => (
            <div className="max-w-screen-md mx-auto px-2 py-4 text-base text-gray-600">
              <h2 className="text-2xl font-bold mb-3 text-center">Residential Cleaning</h2>
              <p className="mb-4 text-lg text-center">
                Brookfield Carpet Cleaning provides a professional carpet and upholstery cleaning service to the residential sector.
              </p>
              <section className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
                <div className="p-4 bg-white rounded-lg shadow text-base">
                  <h3 className="text-xl font-bold mb-3">Upholstery Cleaning - Leather &amp; Fabric</h3>
                  <p className="mb-4">Premium cleaning for home carpets, rugs, and upholstery, using eco-friendly products safe for kids and pets.</p>
                  <ul className="list-disc ml-5 space-y-1">
                    <li>Vacuuming - removes surface dirt and dust</li>
                    <li>Pre-testing of fabric - ensures best cleaning solution</li>
                    <li>Professional stain removal</li>
                    <li>Pre-treatment for stubborn dirt</li>
                    <li>Thorough deep cleaning - leaves fabrics &#39;as good as new&#39;</li>
                  </ul>
                  <ul className="list-disc ml-5 space-y-1 mt-3">
                    <li>Vacuuming - removes surface dirt and dust</li>
                    <li>Pre-testing of leather - assesses leather type</li>
                    <li>Full clean with mild, safe solution</li>
                    <li>Conditioning to protect and prolong leather life</li>
                  </ul>
                  <p className="mt-3 text-sm">Vehicle upholstery cleaning also available.</p>
                </div>
                <div className="p-4 bg-white rounded-lg shadow">
                  <h2 className="text-xl font-bold mb-3">Carpet and Rugs</h2>
                  <p className="mb-4 text-base">Premium cleaning for carpets, rugs, and upholstery, using specialised eco-friendly Prochem products safe for kids and pets.</p>
                  <ul className="list-disc ml-5 space-y-1 text-base">
                    <li>Carpet inspection</li>
                    <li>Dye/Fibre testing for best solution</li>
                    <li>Professional stain removal</li>
                    <li>Pre-treatment for stubborn dirt</li>
                    <li>Deep cleaning with quick drying</li>
                    <li>Free deodorising service</li>
                  </ul>
                  <p className="mt-3 text-lg text-center">Great service and quality work at affordable prices</p>
                </div>
              </section>
            </div>
          );

 const Commercial = () => (
              <div className="px-2 py-4">
                <h2 className="text-2xl md:text-3xl font-bold mb-3 text-center">Commercial Premises</h2>
                <p className="text-gray-600 mb-4 text-base md:text-xl text-center">
                  Brookfield Carpet Cleaning provides professional carpet and upholstery cleaning for businesses: offices, restaurants, nursing homes, public houses, and end of tenancy cleans.<br/><br/>
                  Clean surroundings make a great impression on customers. We work around your trading hours to minimise disruption.<br/><br/>
                  The cleaning process includes:
                </p>
                <ul className="list-disc ml-5 space-y-1 items-center text-base md:text-xl flex flex-col justify-center">
                  <li>Inspection of carpets and upholstery</li>
                  <li>Dye/Fibre testing for best solution</li>
                  <li>Professional stain removal</li>
                  <li>Deep cleaning with quick drying</li>
                  <li>High-tech equipment for fast, effective service</li>
                  <li>Fully trained operatives for utmost care</li>
                  <li>Free deodorising service</li>
                </ul>
                <p className="text-gray-600 mt-4 mb-4 text-base md:text-xl text-center">
                  Quality work at affordable prices!
                </p>
              </div>
            );


  export default function App() {
    return (
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/pricing" element={<Pricing/>}/>
            <Route path="/residential" element={<Residential/>}/>
            <Route path="/commercial" element={<Commercial/>}/>
          </Routes>
        </Layout>
      </Router>
    );
  };

